import React from 'react';
import { Alert as BootstrapAlert, Button, Modal } from 'react-bootstrap';

export default class Alert extends React.Component {
  renderErrorMessage() {
    const { errorMessage } = this.props;
    return (
      <BootstrapAlert bsStyle="danger">
        {errorMessage}
      </BootstrapAlert>
    )
  }

  render() {
    const {
      onPrimaryButtonClick,
      primaryButtonTitle,
      primaryButtonStyle,
      primaryButtonEnabled,
      errorMessage,
      ...newProps
    } = this.props;

    return (
      <Modal
        {...newProps}
        bsSize="large"
        aria-labelledby="contained-modal-title-lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-lg">
            {this.props.title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!!errorMessage && this.renderErrorMessage()}
          <div>{this.props.body}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            bsStyle={primaryButtonStyle || 'primary'}
            onClick={() => onPrimaryButtonClick && onPrimaryButtonClick()}
            disabled={primaryButtonEnabled === undefined ? false : !primaryButtonEnabled}
          >
            {primaryButtonTitle || 'Okay'}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modal/alert/Alert.js